import React from "react";
import CustomButton from "../../UI/Buttons/CustomButton";
import PopupModal from "../../UI/Popup";
import RoundedTick from "../../UI/Icons/RoundedTick";
import Decline from "../../UI/Icons/Decline";

interface TFNConfirmationModalProps {
  visible: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const TFNConfirmationModal: React.FC<TFNConfirmationModalProps> = ({
  visible,
  onConfirm,
  onCancel,
}) => {
  return (
    <PopupModal
      visible={visible}
      showCloseBtn={true}
      onClickClose={onCancel}
      customWidth={650}
    >
      <div className="gap-20 fs-22">Are you confirm?</div>
      <div className="gap-20 fs-13">
        Selecting this option will delete the tax file number you have entered.{" "}
        <br />
        Are you sure you want to continue?
      </div>
      <div className="d-flex gap-20 justify-content-end">
        <CustomButton
          variant={"primary"}
          type="button"
          className="btn-theme bg-teal text-black"
          onClick={onConfirm}
        >
          <RoundedTick />
          {"Yes, I Accept"}
        </CustomButton>

        <CustomButton
          variant={"primary"}
          type="button"
          className="btn-theme bg-off-white text-black"
          onClick={onCancel}
        >
          <Decline />
          {"No"}
        </CustomButton>
      </div>
    </PopupModal>
  );
};

export default TFNConfirmationModal;
